import { render, staticRenderFns } from "./ClipperImage.vue?vue&type=template&id=46b0b599&scoped=true"
import script from "./ClipperImage.vue?vue&type=script&lang=js"
export * from "./ClipperImage.vue?vue&type=script&lang=js"
import style0 from "./ClipperImage.vue?vue&type=style&index=0&id=46b0b599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b0b599",
  null
  
)

export default component.exports